import CodeHighlight from "../../../../src/common/CodeHighlight";
import { UsageExample } from "../../../../src/examples/getting-started/Usage";
import * as React from 'react';
export default {
  CodeHighlight,
  UsageExample,
  React
};